import { Skeleton } from '~/chords/Skeleton';

export function TableCellSkeletonHasActions() {
  return (
    <div className="flex h-2xl w-2xl items-center">
      <Skeleton />
    </div>
  );
}

TableCellSkeletonHasActions.displayName = 'TableCellSkeletonHasActions';
